import { GameFeatureNotepadProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameFeatureNotepadProperties";
import { ManualLayout } from "@lib/titan2/dist/game/control/layout/ManualLayout";
import { Point } from "pixi.js";
export class FeatureNotepadPortraitProperties extends GameFeatureNotepadProperties {
    constructor() {
        super();
        this.position.set(-9, 1592);
        this.scale.set(0.95);
        this.notesPanelProperties.layout = new ManualLayout([
            new Point(0, 0),
            new Point(0, 0),
        ]);
    }
}
//# sourceMappingURL=FeatureNotepadPortraitProperties.js.map